import { FieldHtmlNameUtil, Trans } from '@onshape/www-inertia';
import type UnifiedSignupScreenComponent from '../UnifiedSignupScreenComponent';
import type { UnifiedSignupScreenName } from '../UnifiedSignupScreenName';
import UnifiedSignupStartScreen from '../session-info/UnifiedSignupStartScreen';
import AbstractStartSinupScreen from './AbstractStartSignupScreen';

export default class LandingSignupScreen extends AbstractStartSinupScreen {
  public readonly screenName: UnifiedSignupScreenName = 'uss-start-landing';

  public predicate(): boolean {
    return (
      this.sessionInfo.value.startScreen.compareTo(UnifiedSignupStartScreen.landingPage) &&
      this.sessionInfo.value.emailCheckCode === null
    );
  }

  public override getValidatedComponents(): UnifiedSignupScreenComponent[] {
    this.getField(FieldHtmlNameUtil.email).label = Trans.by('Business Email', 'businessEmail');
    return super.getVisibleComponents();
  }

  public override isInitialScreen(): boolean {
    return true;
  }
}
